import { LocaleEnum, QueriesTypeEnum } from '../enums';

import { AnalyticsMessages, Dictionary } from '../models';

/* tslint:disable:max-line-length */
const DEFAULT_KPIS_MESSAGES_EN = {
  queries: {
    valueLabel: 'queries'
  },
  noResults: {
    valueLabel: 'no results'
  },
  clicks: {
    valueLabel: 'clicks',
    percentageLabel: 'CTR'
  },
  findability: {
    valueLabel: 'success clicks',
    percentageLabel: 'findability'
  },
  add2cart: {
    valueLabel: 'add2carts',
    percentageLabel: 'Add2cart'
  },
  checkout: {
    valueLabel: 'checkouts',
    percentageLabel: 'Checkout'
  },
  sessions: {
    valueLabel: 'sessions'
  },
  queriesPerSession: {
    valueLabel: 'Q/Session'
  }
};

const ANALYTICS_MESSAGES_EN: AnalyticsMessages = {
  kpis: Object.assign({}, DEFAULT_KPIS_MESSAGES_EN, {}),
  details: {
    overall: 'Showing overall data',
    selectedId: 'Showing data for "{terms}"'
  },
  kpisSuccess: {
    overall: 'Search success metrics',
    selectedId: 'Search success metrics for "{terms}"'
  },
  evolutionTitle: 'Evolution over time',
  distributionTitle: 'Queries distribution',
  previousPeriodLabel: 'Previous period {kpi}',
  currentPeriodLabel: 'Current period {kpi}',
  showPercentage: 'Show percentage',
  showRadarChart: 'Show chart',
  kpiNotAvailableInfo: 'Get to know your search efficiency',
  timezone: 'UTC time',
  volume: 'Volume',
  noClicks: 'no clicks',
  queryName: 'Query',
  product: 'Name',
  productId: 'ID',
  quantity: 'Quantity',
  queries: {
    queriesTypes: {
      [QueriesTypeEnum.ALL]: 'All queries',
      [QueriesTypeEnum.WITH_RESULTS]: 'Queries with results',
      [QueriesTypeEnum.WITHOUT_RESULTS]: 'Queries without results'
    },
    distributionTitle: 'Queries distribution for "{query}"',
    relatedTitle: 'Related products for "{query}"',
    search: {
      placeholder: 'Type a query',
      resultsSummary: '{count} queries with "{terms}" ({percentage}% of total)',
      noResultsFound: 'No results found for "{terms}"'
    },
    getBack: 'Get Back',
    downloadQueries: 'Download queries'
  }
};

const DEFAULT_KPIS_MESSAGES_ES = {
  queries: {
    valueLabel: 'queries'
  },
  noResults: {
    valueLabel: 'no results'
  },
  clicks: {
    valueLabel: 'clicks',
    percentageLabel: 'CTR'
  },
  findability: {
    valueLabel: 'success clicks',
    percentageLabel: 'findability'
  },
  add2cart: {
    valueLabel: 'add2carts',
    percentageLabel: 'Add2cart'
  },
  checkout: {
    valueLabel: 'checkouts',
    percentageLabel: 'Checkout'
  },
  sessions: {
    valueLabel: 'sesiones'
  },
  queriesPerSession: {
    valueLabel: 'Q/Sesión'
  }
};

const ANALYTICS_MESSAGES_ES: AnalyticsMessages = {
  kpis: Object.assign({}, DEFAULT_KPIS_MESSAGES_ES, {}),
  details: {
    overall: 'Mostrando datos globales',
    selectedId: 'Mostrando datos para "{terms}"'
  },
  kpisSuccess: {
    overall: 'Métricas de éxito',
    selectedId: 'Métricas de éxito para "{terms}"'
  },
  evolutionTitle: 'Evolución en el tiempo',
  distributionTitle: 'Distribución de queries',
  previousPeriodLabel: '{kpi} periodo anterior',
  currentPeriodLabel: '{kpi} periodo actual',
  showPercentage: 'Mostrar porcentaje',
  showRadarChart: 'Mostrar gráfico',
  kpiNotAvailableInfo: 'Conozca su eficiencia de búsqueda',
  timezone: 'Tiempo UTC',
  volume: 'Volumen',
  noClicks: 'no clicks',
  queryName: 'Query',
  product: 'Nombre',
  productId: 'ID',
  quantity: 'Cantidad',
  queries: {
    queriesTypes: {
      [QueriesTypeEnum.ALL]: 'Todas las búsquedas',
      [QueriesTypeEnum.WITH_RESULTS]: 'Búsquedas con resultados',
      [QueriesTypeEnum.WITHOUT_RESULTS]: 'Búsquedas sin resultados'
    },
    distributionTitle: 'Distribución de queries para "{query}"',
    relatedTitle: 'Productos relacionados para "{query}"',
    search: {
      placeholder: 'Escribe una query',
      resultsSummary: '{count} queries with "{terms}" ({percentage}% of total)',
      noResultsFound: 'No results found for "{terms}"'
    },
    getBack: 'Volver atrás',
    downloadQueries: 'Descargar búsquedas'
  }
};

/* tslint:enable:max-line-length */

export const ANALYTICS_MESSAGES: Dictionary<{ analytics: AnalyticsMessages }> = {
  [LocaleEnum.ENGLISH]: {
    analytics: ANALYTICS_MESSAGES_EN
  },
  [LocaleEnum.SPANISH]: {
    analytics: ANALYTICS_MESSAGES_ES
  }
};
